import { styled, Tag } from '@grupoboticario/flora-react';
import { theme } from 'ui/theme';

export const TagColor = styled(Tag, {
  '&[data-variant="primary"]': {
    background: `${theme.colors.build.brand1}`,
  },
  '&[data-variant="secondary"]': {
    background: `${theme.colors.build.brand2}`,
  },
  '&[data-variant="darkLight"]': {
    background: `${theme.colors.build.darkLight}`,
    color: `${theme.colors.build.lightDark2}`,
  },
  '&[data-variant="medium"]': {
    background: `${theme.colors.build.mediumMedium}`,
  },
  '&[data-variant="disabled"]': {
    background: `${theme.colors.action.navigation.standard.disabled}`,
    color: `${theme.colors.build.mediumMedium}`,
  },
  '&[data-variant="assorted"]': {
    background: `${theme.colors.assorted[9]}`,
  },
  '&[data-variant="error"]': {
    background: `${theme.colors.status.error.standard}`,
  },
  '&[data-variant="success"]': {
    background: `${theme.colors.status.success.standard}`,
  },
  '&[data-variant="alert"]': {
    background: `${theme.colors.status.alert.standard}`,
  },
  '&[data-variant="promotion"]': {
    background: `${theme.colors.action.nonInteractive.emphasis}`,
    color: `${theme.colors.build.lightDark2}`,
  },
  '&[data-variant="lightDark1"]': {
    background: `${theme.colors.build.lightDark1}`,
    color: `${theme.colors.build.darkDark}`,
  },
  '&[data-variant="reward"]': {
    background: `${theme.colors.action.nonInteractive.emphasis}`,
    color: `${theme.colors.build.lightLight}`,
    fontFamily: `${theme.fonts.primary}`,
    fontSize: `${theme.fontSizes.sm}`,
    fontWeight: `${theme.fontWeights.heavy}`,
  },
});
